import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourPremierTransportationSolution from "./sections/YourPremierTransportationSolution";
import DestinationsWeServe from "./sections/DestinationsWeServe";
import ComprehensiveTransportationServices from "./sections/ComprehensiveTransportationServices";
import AirportTransferExpertise from "./sections/AirportTransferExpertise";
import OurLuxuryFleet from "./sections/OurLuxuryFleet";
import WhyChooseCarServiceConnecticut from "./sections/WhyChooseCarServiceConnecticut";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
import WhyChooseUs from "./sections/WhyChooseUs";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import MakeAReservation from "./sections/MakeAReservation";
export default function HomePage() {
  return <div>
      <Header />
      <YourPremierTransportationSolution />
      <DestinationsWeServe />
      <ComprehensiveTransportationServices />
      <AirportTransferExpertise />
      <OurLuxuryFleet />
      <WhyChooseUs />
      <MakeAReservation />
      <WhyChooseCarServiceConnecticut />
      
      <script type="text/javascript" src="https://book.mylimobiz.com/v4/widgets/widget-loader.js"></script>
      <Testimonials />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}